import { Box, Collapse, alpha, styled, Text } from '@ltvco/refresh-lib/theme';

import type { StatusSeverity } from '../utils';

export const RiskSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: 12,
});

export const RiskChip = styled('button')<{ severity: StatusSeverity }>(
  ({ theme, severity }) => {
    const colors = {
      success: {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.dark,
      },
      warning: {
        backgroundColor: alpha(theme.palette.warning.light, 0.2),
        color: theme.palette.warning.main,
      },
      error: {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.dark,
      },
    }[severity];

    return {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '3px 8px',
      border: 'none',
      borderRadius: 100,
      cursor: 'pointer',
      fontWeight: 600,
      ...colors,
    };
  }
);

export const RiskChipLabel = styled(Text)({
  fontWeight: 600,
  lineHeight: 1,
});

export const RiskExpansion = styled(Collapse)({});

export const RiskDescription = styled(Text)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginTop: 8,
  fontSize: 14,
  lineHeight: 1.5,
}));

export const LinkedSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginBottom: 14,
});
